// src/api/servicesApi.js
import { apiClient, getAuthHeader } from "./apiConfig";

export const fetchServices = async () => {
  let user = {};
  try { user = JSON.parse(localStorage.getItem("user")) || {}; } catch {}


  const res = await apiClient.get(`/services/get_all`, {
    ...getAuthHeader(),
  });
  return res.data?.data || [];
};

export const createService = async (payload) => {
  return apiClient.post(`/services/create`, payload, getAuthHeader());
};

export const updateService = async (id, payload) => {
  return apiClient.post(`/services/update/${id}`, payload, getAuthHeader());
};

export const deleteServiceById = async (id) => {
  return apiClient.delete(`/services/delete/${id}`, getAuthHeader());
};
